import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ArticulosProveedorCreateComponent } from './articulos-proveedor-create/articulos-proveedor-create.component';
import { ArticulosProveedorListComponent } from './articulos-proveedor-list/articulos-proveedor-list.component';

const routes: Routes = [

    { path: '', component: ArticulosProveedorListComponent  },
    { path: 'edit/:id', component: ArticulosProveedorCreateComponent },
    { path: 'crear', component: ArticulosProveedorCreateComponent }, 
    { path: 'articulos_proveedor', component: ArticulosProveedorListComponent } 
    
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AppArticulosRoutingModule {}
